import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Row
} from "reactstrap";
import { connect } from "react-redux";
import {
  createCard,
  createCustomer,
  associateCard,
  getCard
} from "../../providers/paymentProvider";
import Toast from "../utils/Toast";
import { updateCustomerId, updateHasCard } from "../../providers/userProvider";

class CreditCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      cardPayload: {
        email: "",
        holder_name: "",
        exp_month: "",
        exp_year: "",
        number: "",
        cvc: ""
      },
      card: {},
      successMessage: "",
      errorMessage: "",
      validationMessage: "",
      loading: false
    };
  }

  async componentDidMount() {
    const {
      firstName,
      lastName,
      email,
      taxPayer,
      hasCard,
      customerId,
      _id,
      token
    } = this.props.profile;

    console.log(hasCard);
    if (hasCard) {
      console.log("Search Card");
      const card = await getCard(email);
      if (!card.error) {
        this.setState({ card: card.result });
      }
      console.log(card);
    }

    console.log(customerId);

    if (!customerId) {
      console.log("Create customer Id");
      //console.log(taxPayer);

      const result = await createCustomer(
        firstName,
        lastName,
        email,
        "03644931356"
      );
      console.log(result);
      if (result.error) {
        return;
      }
      //edit user profile to put customerId
      const updateResult = await this.props.doUpdateCustomerId(
        _id,
        token,
        result.result.id
      );
      if (updateResult.error) {
        //could not update customerId
        return;
      }
      console.log(updateResult);
    }

    this.onChangeCard({
      email
    });
  }

  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen });
  };

  onChangeCard = updateObj => {
    this.setState(prevState => ({
      cardPayload: {
        ...prevState.cardPayload,
        ...updateObj
      }
    }));
  };

  addCard = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    const {
      holder_name,
      email,
      exp_month,
      exp_year,
      number,
      cvc
    } = this.state.cardPayload;

    console.log(this.state.cardPayload);

    //validation
    const invalid = Object.values(this.state.cardPayload).some(
      value => value === ""
    );
    if (invalid) {
      //error message
      this.setState({ loading: false });
      return;
    }

    //send
    const result = await createCard(
      holder_name,
      email,
      exp_month,
      exp_year,
      number,
      cvc
    );

    //error
    if (result.error) {
      this.setState({
        errorMessage:
          "Ocorreu um problema ao adicionar seu cartão, tente novamente",
        loading: false
      });
      setTimeout(() => this.setState({ errorMessage: "" }), 800);
      return;
    }

    //success
    console.log(result);
    const resultAssociation = await associateCard(
      this.state.cardPayload.email,
      result.result.id
    );
    console.log(resultAssociation);

    if (resultAssociation.error) {
      //mensagem de erro
      this.setState({ loading: false });
      return;
    }

    //update user with hasCard: true
    const updateHasCardResult = await this.props.doUpdateHasCard(
      this.props.profile._id,
      this.props.profile.token
    );
    console.log(updateHasCardResult);
    if (updateHasCardResult.error) {
      //error message
      this.setState({ loading: false });
      return;
    }

    this.setState({
      successMessage: "Seu cartão foi adicionado",
      loading: false
    });
    setTimeout(() => this.setState({ successMessage: "" }), 800);
  };

  render() {
    const {
      taxpayer,
      holder_name,
      exp_month,
      exp_year,
      number,
      cvc
    } = this.state.cardPayload;

    console.log(this.state.card);

    return (
      <React.Fragment>
        <h3>Cartão de crédito associado</h3>
        {this.state.card.length > 0 ? (
          <div className="d-flex">
            <p className="mr-2">{this.state.card[0].flag}</p>
            <p>**** **** **** {this.state.card[0].last_number}</p>
          </div>
        ) : null}
        <Button outline onClick={this.toggleModal}>
          Trocar cartão
        </Button>

        <Modal isOpen={this.state.modalOpen} toggle={this.toggleModal}>
          <ModalHeader>Adicionar Cartão</ModalHeader>
          <ModalBody>
            <Form>
              <Row>
                {/* <Col xs="12" sm="6">
                  <FormGroup>
                    <Label>CPF:</Label>
                    <Input
                      value={taxpayer}
                      onChange={e =>
                        this.onChange({ taxpayer: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col> */}
                <Col xs="12" sm="6">
                  <FormGroup>
                    <Label>Nome do titular:</Label>
                    <Input
                      value={holder_name}
                      onChange={e =>
                        this.onChangeCard({ holder_name: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col xs="8" md="9">
                  <FormGroup>
                    <Label>Número do cartão:</Label>
                    <Input
                      value={number}
                      onChange={e =>
                        this.onChangeCard({ number: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col xs="4" md="3">
                  <FormGroup>
                    <Label>CVV:</Label>
                    <Input
                      value={cvc}
                      onChange={e => this.onChangeCard({ cvc: e.target.value })}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <p>Data de expiração</p>
                </Col>
                <Col xs="3" sm="2">
                  <FormGroup>
                    <Label>Mês:</Label>
                    <Input
                      value={exp_month}
                      onChange={e =>
                        this.onChangeCard({ exp_month: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col xs="4">
                  <FormGroup>
                    <Label>Ano:</Label>
                    <Input
                      value={exp_year}
                      onChange={e =>
                        this.onChangeCard({ exp_year: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Button onClick={this.addCard}>Adicionar</Button>
            </Form>
          </ModalBody>
        </Modal>
        {this.state.successMessage ? (
          <Toast message={this.state.successMessage} type="success" />
        ) : null}
        {this.state.errorMessage ? (
          <Toast message={this.state.errorMessage} type="error" />
        ) : null}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    doUpdateCustomerId: (id, token, customerId) =>
      dispatch(updateCustomerId(id, token, customerId)),
    doUpdateHasCard: (id, token) => dispatch(updateHasCard(id, token))
  };
};

export default connect(null, mapDispatchToProps)(CreditCards);
